export const colors = [
    { "name": "Pink", "hex": "#FFC0CB" },
    { "name": "Green", "hex": "#008000" },
    { "name": "Blue", "hex": "#0000FF" },
    { "name": "Red", "hex": "#FF0000" },
    { "name": "Yellow", "hex": "#FFFF00" },
    { "name": "Black", "hex": "#000000" },
    { "name": "Purple", "hex": "#800080" },
    { "name": "Navy Blue", "hex": "#000080" },
    { "name": "Maroon", "hex": "#800000" },
    { "name": "Peach", "hex": "#FFDAB9" },
    { "name": "White", "hex": "#FFFFFF" },
    { "name": "Grey", "hex": "#808080" },
    { "name": "Teal", "hex": "#008080" },
    { "name": "Turquoise Blue", "hex": "#00CED1" },
    { "name": "Mustard", "hex": "#FFDB58" },
    { "name": "Beige", "hex": "#F5F5DC" },
    { "name": "Cream", "hex": "#FFFDD0" },
    { "name": "Sea Green", "hex": "#2E8B57" },
    { "name": "Orange", "hex": "#FFA500" },
    { "name": "Brown", "hex": "#964B00" },
    { "name": "Off White", "hex": "#FAF0E6" },
    { "name": "Burgundy", "hex": "#800020" },
    { "name": "Lavender", "hex": "#E6E6FA" },
    { "name": "Magenta", "hex": "#FF00FF" },
    { "name": "Olive", "hex": "#808000" },
    { "name": "Mauve", "hex": "#E0B0FF" },
    { "name": "Lime Green", "hex": "#32CD32" },
    { "name": "Gold", "hex": "#FFD700" },
    { "name": "Rust", "hex": "#B7410E" },
    { "name": "Coral", "hex": "#FF7F50" },
    { "name": "Rose", "hex": "#FF007F" },
    { "name": "Coffee Brown", "hex": "#4B3621" },
    { "name": "Fluorescent Green", "hex": "#00FF00" },
    { "name": "Silver", "hex": "#C0C0C0" },
    { "name": "Taupe", "hex": "#483C32" },
    { "name": "Tan", "hex": "#D2B48C" },
    { "name": "Nude", "hex": "#FFFAE6" },
    { "name": "Metallic", "hex": "#D4AF37" },
    { "name": "Khaki", "hex": "#C3B091" },
    { "name": "Grey Melange", "hex": "#BEBEBE" },
    { "name": "Charcoal", "hex": "#36454F" },
    { "name": "Bronze", "hex": "#CD7F32" },
    { "name": "Denim", "hex": "#1560BD" }

    ];
  